import { ScreenEntry } from "./screens/entry";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ScreenWorks } from "./screens/works";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: "PT Mono", monospace;
      font-size: 14px;
    letter-spacing: 0em;
     font-weight: 500;
  }
`;

const router = createBrowserRouter([
  {
    path: "/",
    element: <ScreenEntry />,
  },
  {
    path: "/works",
    element: <ScreenWorks />,
  },
]);

function App() {
  return (
    <>
      <GlobalStyle />
      <RouterProvider router={router} />
    </>
  );
}

export default App;
